import { Analytics } from "@vercel/analytics/react";
import './App.css';
import Booking from './components/Booking';
import Footer from './components/Footer';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
export default function App() {
  return (
    <>
      <Analytics />
      <Header />
      <Hero />
      <Services />
      <Booking />
      <Footer />
      
    </>
  );
}
